

















































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { PendingPersonalContribution } from "@/shared/types";

import { Location } from "vue-router";
import { formatDateString } from "@/shared/dateString";
import { formatCurrency } from "@/shared/currency";

import Edit from "./Edit.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import { usePendingPersonalContributionStore } from "@/admin/store/pendingPersonalContribution";

@Component({
  components: { Pagination, Edit }
})
export default class List extends Vue {
  formatDateString = formatDateString;
  formatCurrency = formatCurrency;

  personalContributionStore = usePendingPersonalContributionStore();

  @Prop() pageNumber: number;
  @Prop() detailId: string;

  @Prop() routeToPage: (pageNumber: number) => Location;
  @Prop() routeToItem: (recordId: number) => Location;

  created (): void {
    this.loadComponent();
  }

  loadComponent (): void {
    if (this.detailId) {
      this.personalContributionStore.loadDetailById(this.detailId as any)
          .catch(_ => { /* noop */
          });
      return;
    }
    this.personalContributionStore.loadItems({ pageNumber: this.pageNumber || 1 })
        .catch(_ => { /* noop */
        });
  }

  @Watch("pageNumber")
  @Watch("detailId")
  onRouteValuePageNumberChanged () {
    this.loadComponent();
  }

  get isLoading (): boolean {
    return this.personalContributionStore.getLoadedItems === null;
  }

  get canGoBack () {
    return this.pageNumber > 1;
  }

  get showDetail () {
    return !!this.detailId;
  }

  get showListing () {
    return !this.showDetail;
  }

  get fieldConfiguration () {
    return [
      { key: "pendingPersonalContributionId", label: "" },
      { key: "email" },
      { key: "firstName" },
      { key: "lastName" },
      { key: "amount" },
      { key: "dateCreated" },
      { key: "status" },
      { key: "dateToProcess", label: "Transfer Date" }
    ];
  }

  switchPage (page: number) {
    this.$router.push(this.routeToPage(page));
  }

  editClick (item: PendingPersonalContribution) {
    this.$router.push(this.routeToItem(item.pendingPersonalContributionId));
  }
}
